import { AppAction, AsyncAction } from 'actions/actions.types'
import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { afterSendMessageAction } from 'actions/messenger/afterSendMessageAction'
import { Api6Error } from 'api/api.types'
import { sendMessageSwitchApi } from 'api/messenger/chatMessengerApi'
import { DeprecatedApi6Error } from 'api/types'
import { hasUserRestrictions } from 'functions/hasUserRestrictions'

export const SEND_MESSAGE = 'SEND_MESSAGE'

export interface SendMessageAction extends AsyncAction<DeprecatedApi6Error> {
  type: typeof SEND_MESSAGE
  message: string
}

export const sendMessageAction =
  (profileId: number, message: string) =>
  async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const state = getState()
    const {
      chatMessengerReducer: { replyMessageId, editMessageId },
    } = state

    const { result: json } = (await dispatch({
      type: SEND_MESSAGE,
      promise: () =>
        sendMessageSwitchApi(
          profileId,
          message,
          hasUserRestrictions(state),
          replyMessageId,
          editMessageId
        ),
      message,
    } as AppAction)) as unknown as { result: Api6Error }

    await dispatch(afterSendMessageAction(json as unknown as Api6Error))

    return Promise.resolve()
  }
